import { useThreadModel } from '@/contexts/thread-model-context';
import { isEmpty } from 'lodash';

interface ThreadModelTagProps {
  model: string;
}

const ThreadModelTag = ({ model }: ThreadModelTagProps) => {
  const { modelMap, isLoading } = useThreadModel();

  if (isLoading || isEmpty(modelMap) || !model) {
    return null;
  }

  return (
    <span className="inline-flex items-center justify-center mx-2 h-[26px] px-2 text-[#7171EE] bg-[#7171EE33] rounded-[8px] text-[14px] shrink-0">
      {modelMap.get(model)?.name || model}
    </span>
  );
};

export default ThreadModelTag;
